import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function LifelapseNew() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 15% 20%, rgba(242, 176, 94, 0.2), transparent 50%), linear-gradient(135deg, #0f1417, #1a2329 60%, #0b1114 100%)",
        color: "#f8f5f1",
        fontFamily: '"Avenir Next", "Avenir", "Gill Sans", "Trebuchet MS", sans-serif',
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={3} sx={{ textAlign: { xs: "left", md: "center" } }}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: '"Palatino Linotype", "Book Antiqua", Palatino, serif',
              fontWeight: 700,
            }}
          >
            New scene studio
          </Typography>
          <Typography variant="body1" sx={{ color: "rgba(248,245,241,0.75)" }}>
            Placeholder for capture, onion-skin overlay, and audio upload. Next step: wire the
            camera and storage flow here.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <Button
              variant="contained"
              component={Link}
              to="/lifelapse"
              sx={{
                background: "linear-gradient(120deg, #88d4c1, #f2b05e)",
                color: "#0f1b1e",
                fontWeight: 800,
                borderRadius: 3,
                px: 4,
              }}
            >
              Back to feature page
            </Button>
            <Button
              variant="outlined"
              component={Link}
              to="/"
              sx={{
                borderColor: "rgba(248,245,241,0.35)",
                color: "#f8f5f1",
                borderRadius: 3,
                px: 4,
                fontWeight: 700,
              }}
            >
              Home
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
